export const SET_TOGGLE = 'SET_TOGGLE';